import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNiue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1655)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 5.73914V9.78646L7.82611 5.73914H12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26085 12H9.78637L6.26085 7.30435L5.73914 10.9565L6.26085 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9679 12H12C12 11.9892 12 11.9787 12 11.9679C11.9893 11.9786 11.9786 11.9893 11.9679 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78638 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47444 6.26086H12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 10.5243L7.73649 6.26093H6.26086V6.26102L11.9999 12H12C12 12 12 10.9825 12 10.5243Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.07103 1.56522C5.60842 1.82865 5.16522 2.12223 4.74372 2.44272H5.23609L3.93475 3.38837L4.43172 4.91823L3.13037 3.97276L2.9919 4.07341C2.45158 4.687 1.97251 5.35581 1.56522 6.07103V12H4.69567V4.69576V4.69567H12C12 3.70834 12 2.76775 12 1.56522H6.07103Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.12625 2.16336C4.99683 2.25397 4.86924 2.34711 4.74356 2.44269L3.93474 3.38835L3.13036 3.97269L2.99072 4.07413C2.69606 4.40881 2.41974 4.76 2.16333 5.12624C2.4556 5.26808 2.78367 5.34781 3.13036 5.34781C4.35502 5.34781 5.34774 4.35509 5.34774 3.13044C5.34783 2.78366 5.26814 2.45567 5.12625 2.16336Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.99078 4.07416L3.13042 3.97272L4.43177 4.91823L3.93475 3.38837L5.236 2.44272H4.74353C4.10631 2.92736 3.51911 3.47411 2.99078 4.07416Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.29418 2.08698L8.55321 2.88408H9.39134L8.71329 3.37679L8.97218 4.1739L8.29418 3.68124L7.61613 4.1739L7.87498 3.37679L7.19693 2.88408H8.0351L8.29418 2.08698Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.13047 7.30435L3.3895 8.10146H4.22762L3.54962 8.59421L3.80851 9.39132L3.13047 8.89862L2.45237 9.39132L2.71126 8.59421L2.03326 8.10146H2.87139L3.13047 7.30435Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1655",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNiue;
